module.exports = __webpack_public_path__ + "media/images/pepsi--large-593aca09a63a9df28626fe84c38d9aa9.png";